import { Component, OnInit } from "@angular/core";
import { ModalController } from "src/app/core/overlay";
import { NavService } from "src/app/core/services/nav.service";
// Direto do serviço, NÃO pelo barrel `src/app/core`: o order.service agora importa esta
// página (modal de item sem estoque), e o barrel puxa o core.module de volta — o ciclo
// deixava ShoppingCartService indefinido no boot ("cannot access before initialization").
import { RestaurantService } from "src/app/core/services/restaurant.service";

@Component({
	selector: "app-message-error-order-dialog",
	templateUrl: "./message-error-order-dialog.page.html",
	styleUrls: ["./message-error-order-dialog.page.scss"],
})
export class MessageErrorOrderDialogPage implements OnInit {
	header: string;
	message: string;
	error: any;
	type: 'generic' | 'stock' = 'generic';
	isNewFlowCheckoutPedirDelivery = !!this.restaurantService.restaurant?.info?.modules?.new_flow_checkout_pedir_delivery;

	constructor(
		private modalCtrl: ModalController,
		private navService: NavService,
		private restaurantService: RestaurantService,
	) {}

	ngOnInit() {}

	followOrder() {
		this.navService.push("/track", { token: this.error.lastOrderUUID });
		this.dismiss();
	}

	async dismiss() {
		await this.modalCtrl.dismiss({
			dismissed: true,
		});
	}
}
